import { Api, BuildVersion, currentver } from "../../config/config";
import { dto_Customer } from "../../classes/dto-customer";
import { postMethod } from "../post";
import { dto_common } from "../../classes/dto-common";

export const api_CheckMobilePhoneNumber = (PHONE_NO) => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"CheckMobilePhoneNumber","CSP":"' +
      dto_common.CSP +
      '","CODE":"' +
      PHONE_NO +
      '","TYPE": 2}',
  );
};

export const api_SaveCustomer = (
  FullName,
  Phone,
  Add1,
  Add2,
  City,
  ZoneID,
  navigation,
) => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"SaveCustomer","CSID":0,"FULLNAME":"' +
      FullName +
      '","PHONENUMBER":"' +
      Phone +
      '","ADD1":"' +
      Add1 +
      '","ADD2":"' +
      Add2 +
      '","ADD3":"' +
      City +
      '","ZONEID":"' +
      ZoneID +
      '","TYPE":2,"EXPOPUSHTOKEN":"' +
      dto_Customer.PushToken +
      '","":"' +
      dto_Customer.NIC +
      '","VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};

export const api_ReSendOTP = (PHONE_NO) => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"MCP","CSP":"' +
      dto_common.CSP +
      '","PHONENUMBER":"' +
      PHONE_NO +
      '","OTPCODE": 0}',
  );
};

export const api_VarifyCustomerOTP = (CSID, OTPCode) => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"VarifyCustomerOTP","CSID":' +
      CSID +
      ',"OTPCODE":' +
      parseInt(OTPCode) +
      ',"NIC":"' +
      dto_Customer.NIC +
      '","VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};

export const api_GetCustomerDeliveryZones = () => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"GetCustomerDeliveryZones","CSID":' +
      dto_Customer.CSID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};

export const api_GetCustomerDeliveryAddress = () => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"GetCustomerDeliveryAddress","CSID":' +
      dto_Customer.CSID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};

export const api_LoadCustomerWiseMerchantFavouriteListToMemory = () => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"LoadCustomerWiseMerchantFavouriteListToMemory","CSID":' +
      dto_Customer.CSID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};

export const api_SaveCustomerDeliveryAddress = (
  ADD1,
  ADD2,
  ADD3,
  FULLNAME,
  PHONENUMBER,
  ZONEID,
  cordinates,
) => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"SaveCustomerDeliveryAddress","CSID":' +
      dto_Customer.CSID +
      ',"ADD1":"' +
      ADD1 +
      '","ADD2":"' +
      ADD2 +
      '","ADD3":"' +
      ADD3 +
      '","FULLNAME":"' +
      FULLNAME +
      '","PHONENUMBER":"' +
      PHONENUMBER +
      '","ZONEID":' +
      ZONEID +
      ',"LOCATION":"' +
      cordinates +
      '","ISCUSTOMERADDEDADDRESS":true,"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      cordinates +
      '"}',
  );
};

export const api_UpdateCustomerDeliveryAddress = (GUID, INACTIVE = false) => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"UpdateCustomerDeliveryAddress","CSID":' +
      dto_Customer.CSID +
      ',"INACTIVE":' +
      INACTIVE +
      ',"GUID":' +
      GUID +
      ',"ISDEFAULT":true,"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '"}',
  );
};

export const api_UpdateExpoPushToken = () => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"UpdateExpoPushToken","CSID":' +
      dto_Customer.CSID +
      ',"EXPOPUSHTOKEN":"' +
      dto_Customer.PushToken +
      '","APPVERSION":"' +
      currentver +
      "|" +
      dto_Customer.DeviceInfo +
      '","NIC":"' +
      dto_Customer.NIC +
      '","VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};

//#region api_GenerateNIC
export const api_GenerateNIC = () => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"GenerateNIC","VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};
//#endregion

export const api_SaveNIC = () => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"SaveNIC","EXPOPUSHTOKEN":"' +
      dto_Customer.PushToken +
      '","APPVERSION":"' +
      BuildVersion +
      "|" +
      dto_Customer.DeviceInfo +
      '","PUBLICIP":"0","NIC":"' +
      dto_Customer.NIC +
      '","VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};

export const api_SendOtp = (PhoneNo) => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"SendOtp","PHONENUMBER": "' +
      PhoneNo +
      '","VERSION":"' +
      BuildVersion +
      '","TYPE":2,"CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};

export const api_InactiveIOSUser = () => {
  //deleteAccountForFake
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    '{"SERVICENAME":"InactiveIOSUser","CSID":' +
      dto_Customer.CSID +
      ',"CSP":"' +
      dto_common.CSP +
      '"}',
  );
};

export const api_LoadCompletedSalesOrderForCustomerMobileApp = () => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    "{'SERVICENAME':'LoadCompletedSalesOrderForCustomerMobileApp',CSID:" +
      dto_Customer.CSID +
      ",'VERSION':'" +
      BuildVersion +
      "','CSP':'" +
      dto_common.CSP +
      "','COUNTRYCODE':'" +
      dto_common.NatvieCountry +
      "','COORDINATES':'" +
      dto_common.CurrentCordinate +
      "'}",
  );
};

export const api_LoadCancelledSalesOrderForCustomerMobileApp = () => {
  var url = `${Api}/?ControllerName104=/ApiProfile`;
  return postMethod(
    url,
    "{'SERVICENAME':'LoadCancelledSalesOrderForCustomerMobileApp',CSID:" +
      dto_Customer.CSID +
      ",'VERSION':'" +
      BuildVersion +
      "','CSP':'" +
      dto_common.CSP +
      "','COUNTRYCODE':'" +
      dto_common.NatvieCountry +
      "','COORDINATES':'" +
      dto_common.CurrentCordinate +
      "'}",
  );
};
